import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpExtendedService } from './http-extended.service';
import { TextModel } from 'src/models/text';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class TextService {

  constructor(
    private http: HttpExtendedService,
    private config: ConfigService
  ) {

  }

  getText(textId: string, lang: string): Observable<string> {
    return this.http.getResources<string>(`${this.config.config.textResources}/${lang}/${textId}`, { responseType: 'text' as 'json' });
  }

  saveText(text: TextModel): Observable<string> {
    return this.http.post<string>(this.config.config.textUrl, text, { responseType: 'text' as 'json' });
  }

}
